import React, { Component } from "react";
import AppRouter from "./core/Routes";

class App extends Component {
  render() {
    return (
      <div className="flexContainer appContainer">
        <div className="flexContainerColumn">
          <AppRouter />
        </div>
      </div>
    );
  }
}

export default App;
